import * as React from 'react';
import * as c from 'models/constants';
import { Field, reduxForm, InjectedFormProps, getFormSyncErrors } from 'redux-form';
import { getUserProfile, putUserProfile, deactivateUser } from 'modules/user/userprofile';
import { IUserProfile, IUserProfileData, IUserProfileAction } from 'models/user/userprofile';
import { translate } from 'react-i18next';
const { connect } = require('react-redux');
import { TabLink, TabContent, Tabs } from 'react-tabs-redux';
import { IDomainValue, ITranslateProps } from 'models/common';
import { PortalTopPart } from 'components/PortalStructure/Layouts/Portal/PortalTopPart';
import { BookingSelectMenu, PortalInputField, PortalSelectMenu, PortalSwitchField } from 'components/FormControls';
import { LoadingOverlayWrapper } from 'components/Loader/LoadingOverlayWrapper';
import { IStore } from 'redux/IStore';
import { Dispatch } from 'react-redux';
import { RouteComponentProps, browserHistory } from 'react-router';
import { getOneShopCustomer } from 'redux/modules/shop/shopcard';
import { email, maxLength, phoneNumber, required } from 'helpers/validationattributes';
import { PortalOneColumnLayout } from 'components/PortalStructure';
import { ShopCustomerNotes } from './ShopCustomerNotes';
import Appointments from 'containers/User/Appointments';
import { getAppointmentsByCustomer } from 'redux/modules/shop/appointments';
import { ShopCustomerBio } from './ShopCustomerBio';
import { PortalPageSection } from 'components/PortalStructure';
import { Button } from 'components';
import { ICustomer } from 'models/shop/customer';
import { updateShopCustomer } from 'redux/modules/shop/shopcard';
import {
	createDomainValueOptions,
	createLanguageDropdownValues,
	fullPhoneNumber,
	getCustomerTabUrl,
} from 'helpers/common';
import { domainValuesMap } from 'redux/modules/domainvalues';
import * as i18n from 'i18next';

interface IParams {
	id: string;
	customerId: string;
}
interface IProps
	extends RouteComponentProps<IParams, {}>,
		Partial<ITranslateProps>,
		ReturnType<typeof mapStateToProps>,
		ReturnType<typeof mapDispatchToProps> {
	/* form props */
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;
	domainValuesMap?: any;
}

interface IProps extends InjectedFormProps {
	userProfile: IUserProfileData;
	currentFormValues: IUserProfile;
	countryCallingCodes?: IDomainValue[];
	/* form props */
	dirty: boolean;
	submitting: boolean;
	handleSubmit: any;
	submitFailed: boolean;
	formErrors?: any;
	pristine: boolean;

	/* functions props */
	t?: (key: string, props?: any) => string;
	change: (field: string, data: any) => void;
	deactivateUser?: () => void;
	notifSend?: (data: any) => void;
	reset: () => void;
	putUserProfile: (user: IUserProfile) => IUserProfileAction;
	// getOnboardingQuiz: () => IOnboardingQuizAction;
}
interface IState {
	activeTab: typeof c.CUSTOMER_OVERVIEW | typeof c.CUSTOMER_BIO | typeof c.CUSTOMER_APPOINTMENTS;
	readOnlyProfile: boolean;
	readOnlyBio: boolean;
	togglesChanged: boolean;
	customerSettingsChanged: boolean;
}

const maxLength100 = maxLength(100);
const maxLength50 = maxLength(50);

const validateEmailPhone = (_value, values) => {
	if (values?.phoneNumber || values?.email) {
		return undefined;
	} else {
		return i18n.t('Validation_Field_EmailOrPhone');
	}
};

const validatePhonePrefix = (_value, values) => {
	if (values?.phoneNumber && !values?.callingCodeKey) {
		return i18n.t('Validation_Client_Field_Required');
	} else {
		return undefined;
	}
};

@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class ShopCustomerComponent extends React.Component<IProps, IState> {
	shopCustomerNotesRef = React.createRef();

	constructor(props) {
		super(props);
		this.shopCustomerNotesRef = React.createRef();
		this.state = {
			togglesChanged: false,
			activeTab: c.CUSTOMER_OVERVIEW,
			readOnlyProfile: true,
			readOnlyBio: true,
			customerSettingsChanged: false,
		};
		this.handleCustomerTabClick = this.handleCustomerTabClick.bind(this);
		this.handleCustomerSettingsChange = this.handleCustomerSettingsChange.bind(this);
		this.toggleReadOnlyProfile = this.toggleReadOnlyProfile.bind(this);
		this.onSubmit = this.onSubmit.bind(this);
		this.onSubmitNotifications = this.onSubmitNotifications.bind(this);
		this.onSubmitCustomerSettings = this.onSubmitCustomerSettings.bind(this);
	}

	componentDidMount() {
		const { location } = this.props;
		const customerId = this.props.params.customerId;
		if (customerId) {
			this.props.getOneShopCustomer(customerId);
			this.props.getAppointmentsByCustomer(customerId, 1);
		}

		if (location?.query?.tab && location?.query?.tab?.length > 0) {
			this.setState({ activeTab: location.query.tab });
		}

		this.props.getCountryCallingCodeDomainValues();
	}

	private handleNotesFormOpen = () => {
		if (this.state.readOnlyProfile == false) {
			this.setState(() => {
				return {
					readOnlyProfile: true,
				};
			});
		}
		// Handle the event here
	};

	private toggleReadOnlyProfile() {
		this.setState((s) => {
			return {
				readOnlyProfile: !s.readOnlyProfile,
			};
		});
	}

	private handleCustomerTabClick(selectedTab: IState['activeTab']) {
		this.handleNotesFormOpen();
		this.setState({ activeTab: selectedTab });
	}

	public onSubmit(form: ICustomer) {
		this.props.updateShopCustomer(form);
		this.toggleReadOnlyProfile();
	}

	public onSubmitNotifications(form: ICustomer) {
		this.props.updateShopCustomer(form);
		this.setState({ togglesChanged: false });
	}

	public onSubmitCustomerSettings(form: ICustomer) {
		this.props.updateShopCustomer(form);
		this.setState({ customerSettingsChanged: false });
	}

	public handleToggleChange = () => {
		this.setState((state) => ({ togglesChanged: !state.togglesChanged }));
	};

	public handleCustomerSettingsChange = () => {
		this.setState((state) => ({ customerSettingsChanged: !state.customerSettingsChanged }));
	};

	private renderReadOnlyBio() {
		const { t, selectedCustomer } = this.props;
		return (
			<dl className="list">
				<dt>{t('User_Shipping_ManageShippingAddress_Label_Name')}</dt>
				<dd>{selectedCustomer.name}</dd>
				<dt>{t('User_UserProfile_Label_PhoneNumber')}</dt>
				<dd>{fullPhoneNumber(t, selectedCustomer?.callingCodeKey, selectedCustomer?.phoneNumber)}</dd>
				<dt>{t('User_UserPreferences_Label_Email')}</dt>
				<dd>{selectedCustomer.email}</dd>
			</dl>
		);
	}

	private renderEditableBio() {
		const { t, countryCallingCodes, currentFormValues, change } = this.props;
		const callingCodes = createDomainValueOptions(t, 'DV_CountryCallingCodes_', countryCallingCodes);

		return (
			<>
				<Field
					name="name"
					component={PortalInputField}
					type="text"
					validate={[maxLength50, required]}
					label={[t('User_UserProfile_Label_GivenName'), ' ', t('User_UserProfile_Label_FamilyName')]}
				/>
				<Field
					name={'callingCodeKey'}
					component={PortalSelectMenu}
					type="text"
					items={callingCodes}
					withImages={true}
					multi={false}
					isRequired={true} // to remove empty value
					label={t('BSPortal_Common_Phone_Prefix')}
					validate={[validatePhonePrefix]}
				/>
				<Field
					name={'phoneNumber'}
					component={PortalInputField}
					type="text"
					label={t('PhoneNumber_Label')}
					validate={[phoneNumber, validateEmailPhone]}
				/>
				<Field
					name="email"
					component={PortalInputField}
					type="text"
					validate={[maxLength100, email, validateEmailPhone]}
					onBlurAction={() => {
						// Trim before and after spaces
						if (currentFormValues?.email?.length) {
							change('email', currentFormValues.email.trim());
						}
					}}
					label={t('User_UserPreferences_Label_Email')}
				/>
				<Button className="formButton" type="submit">
					{t('BSPortal_Common_Save')}
				</Button>
			</>
		);
	}

	private handleOverviewClick = () => {
		if (this.props?.params?.id && this.props?.params?.customerId) {
			browserHistory.push(
				`/shop/${this.props.params.id}/customer/${this.props.params.customerId}${getCustomerTabUrl('overview')}`,
			);
		}
	};

	private handleBioClick = () => {
		if (this.props?.params?.id && this.props?.params?.customerId) {
			browserHistory.push(
				`/shop/${this.props.params.id}/customer/${this.props.params.customerId}${getCustomerTabUrl('bio')}`,
			);
		}
	};
	private handleAppointmentsClick = () => {
		if (this.props?.params?.id && this.props?.params?.customerId) {
			browserHistory.push(
				`/shop/${this.props.params.id}/customer/${this.props.params.customerId}${getCustomerTabUrl('appointments')}`,
			);
		}
	};

	render() {
		const { t, handleSubmit, params, selectedCustomer, appointments, submitting, languageDomainValues } = this.props;
		const { activeTab } = this.state;
		const languages = createLanguageDropdownValues(languageDomainValues, t);

		return (
			<div className="shopCustomerCard">
				<PortalTopPart item={selectedCustomer} backLink={`/shop/${params.id}/edit/customers`} />
				<PortalOneColumnLayout>
					<Tabs
						name="customerTopMenu"
						tabComponent="div"
						selectedTab={activeTab}
						handleSelect={(selectedTab: typeof activeTab) => {
							this.handleCustomerTabClick(selectedTab);
						}}
					>
						<div className="tabsText">
							<TabLink
								key="customerTopMenuOverview"
								to={c.CUSTOMER_OVERVIEW}
								onClick={() => this.handleOverviewClick()}
							>
								{t('Shop_ShopCard_Overview_Title')}
							</TabLink>
							<TabLink key="customerTopMenuBio" to={c.CUSTOMER_BIO} onClick={() => this.handleBioClick()}>
								{t('User_UserProfile_Bio')}
							</TabLink>
							<TabLink
								key="customerTopMenuAppointments"
								to={c.CUSTOMER_APPOINTMENTS}
								onClick={() => this.handleAppointmentsClick()}
							>
								{t('User_UserCard_Appointments')}
							</TabLink>
						</div>
						<TabContent
							key="customerTopMenuOverviewContent"
							for={c.CUSTOMER_OVERVIEW}
							style={{ position: 'relative' }}
							className="customerTabContent"
						>
							<LoadingOverlayWrapper active={!selectedCustomer?.id}>
								{/* // TODO Reviews */}
								<form onSubmit={handleSubmit(this.onSubmit)} className="editForm">
									<PortalPageSection
										title={t('User_UserProfile_Bio')}
										readOnly={this.state.readOnlyProfile}
										variant="dark"
										toggleEdit={this.toggleReadOnlyProfile}
										className="customerTabContent__card"
									>
										{this.state.readOnlyProfile ? this.renderReadOnlyBio() : this.renderEditableBio()}
									</PortalPageSection>
								</form>

								<ShopCustomerNotes
									selectedTab={this.state.activeTab}
									readOnly={this.state.readOnlyProfile}
									onFormOpen={this.handleNotesFormOpen}
									customCardClassName={'customerTabContent__card'}
								/>

								<form onSubmit={handleSubmit(this.onSubmitNotifications)} className="editForm">
									<PortalPageSection
										title={t('Shop_ShopCustomer_Notifications_Title')}
										variant="dark"
										className="customerNotifications customerTabContent__card"
									>
										<Field
											name="isEmailNotificationEnabled"
											component={PortalSwitchField}
											type="checkbox"
											label={t('Shop_ShopCustomer_Email_Notifications')}
											onChange={this.handleToggleChange}
										/>
										<Field
											name="isSMSNotificationEnabled"
											component={PortalSwitchField}
											type="checkbox"
											label={t('Shop_ShopCustomer_SMS_Notifications')}
											onChange={this.handleToggleChange}
										/>
										<div className={`customerLanguagePicker ${selectedCustomer?.userId ? 'd-none' : ''}`}>
											{' '}
											{/** Hide language picker if user exists as only the user can change it's language */}
											<Field
												name="languageKey"
												component={BookingSelectMenu}
												parse={(value) => (value ? Number(value) : null)}
												items={languages}
												type="number"
												label={t('User_UserPreferences_Label_Language')}
												information={t('User_UserPreferences_Label_Language')}
												isRequired={true} // Hide empty selection, doesn't enforce required!
												onChange={this.handleToggleChange}
												searchable={false}
											/>
										</div>
										<Button type="submit" disabled={!this.state.togglesChanged || submitting}>
											{t('BSPortal_Common_Save')}
										</Button>
									</PortalPageSection>
								</form>

								<form onSubmit={handleSubmit(this.onSubmitCustomerSettings)} className="editForm">
									<PortalPageSection
										title={t('Shop_ShopCustomer_CustomerSettings')}
										variant="dark"
										className="customerNotifications customerTabContent__card"
									>
										<Field
											name="isBlacklisted"
											component={PortalSwitchField}
											type="checkbox"
											label={t('Shop_ShopCustomer_RestrictCustomer')}
											onChange={this.handleCustomerSettingsChange}
										/>
										<p className="customerSettingsText">{t('Shop_ShopCustomer_RestrictCustomersText')}</p>
										<Button type="submit" disabled={!this.state.customerSettingsChanged || submitting}>
											{t('BSPortal_Common_Save')}
										</Button>
									</PortalPageSection>
								</form>
							</LoadingOverlayWrapper>
						</TabContent>

						<TabContent
							key="customerTopMenuBioContent"
							for={c.CUSTOMER_BIO}
							style={{ position: 'relative' }}
							className="customerTabContent"
						>
							<LoadingOverlayWrapper active={!selectedCustomer?.id}>
								<ShopCustomerBio customCardClassName={'customerTabContent__card'} />
							</LoadingOverlayWrapper>
						</TabContent>

						<TabContent
							key="customerTopMenuAppointmentsContent"
							for={c.CUSTOMER_APPOINTMENTS}
							style={{ position: 'relative' }}
							className="customerTabContent"
						>
							<LoadingOverlayWrapper
								active={!selectedCustomer?.id || this.props?.appointments?.isFetching}
								className="loadingOverlayWrapper-appointments"
							>
								<Appointments
									appointments={appointments}
									isShopAppointment={true}
									isShopCustomerAppointment={true}
									loadMoreData={() =>
										this.props.getAppointmentsByCustomer(
											this.props.params.customerId,
											this.props.appointments.itemsPage.currentPage + 1,
										)
									}
								/>
							</LoadingOverlayWrapper>
						</TabContent>
					</Tabs>
				</PortalOneColumnLayout>
			</div>
		);
	}
}

let UserProfile = reduxForm({
	form: c.FORM_NAME_CUSTOMERPROFILE,
	enableReinitialize: true,
	onSubmit: updateShopCustomer,
})(ShopCustomerComponent);

UserProfile = connect(
	(state: IStore) => {
		let currentFormValues: ICustomer = null;
		if (state.form[c.FORM_NAME_CUSTOMERPROFILE] && state.form[c.FORM_NAME_CUSTOMERPROFILE].values) {
			currentFormValues = state.form[c.FORM_NAME_CUSTOMERPROFILE].values;
		} else {
			currentFormValues = state.shopcard.selectedCustomer;
		}

		const initialValues = state.shopcard.selectedCustomer
			? { ...state.shopcard.selectedCustomer }
			: state.shopcard.selectedCustomer;

		return {
			initialValues,
			userProfile: state.userprofile,
			userPreferences: state.userPreferences,
			currentFormValues,
			formErrors: getFormSyncErrors(c.FORM_NAME_USERPROFILE)(state),
			baseUrlClient: state.fetchDefault.baseUrlClient,
			countryCallingCodes: state.domainValues.countryCallingCodes,
		};
	},
	(dispatch) => ({
		putUserProfile: (form: IUserProfile) => dispatch(putUserProfile(form)),
		deactivateUser: () => dispatch(deactivateUser()),
		getUserProfile: () => dispatch(getUserProfile()),
		// getOnboardingQuiz: () => dispatch(getOnboardingQuiz())
	}),
)(UserProfile);

const mapStateToProps = (state: IStore) => ({
	selectedCustomer: state.shopcard.selectedCustomer,
	appointments: state.appointments,
	languageDomainValues: state.domainValues.languages,
});
const mapDispatchToProps = (dispatch: Dispatch<IStore>) => ({
	updateShopCustomer: (newData: Partial<ICustomer>) => dispatch(updateShopCustomer(newData)),
	getOneShopCustomer: (customerId: string) => dispatch(getOneShopCustomer(customerId)),
	getAppointmentsByCustomer: (customerId: string, currentPage?: number) =>
		dispatch(getAppointmentsByCustomer(customerId, currentPage, true)),
	getCountryCallingCodeDomainValues: () => dispatch(domainValuesMap.countryCallingCodes()),
	getLanguageDomainValues: () => dispatch(domainValuesMap.languages()),
});

let ShopCustomer = UserProfile;
ShopCustomer = connect(mapStateToProps, mapDispatchToProps)(ShopCustomer);

export { ShopCustomer };
